<template>
  <div>
    <viewTable
      ref="viewTable"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      @select="selectHandle"
      url="warehouses/kingdee"
      @reset="resetHandle"
    >
      <template slot="otherBtn">
        <el-button type="primary" :disabled="!selection.length" @click="printHandle">仓库条码打印</el-button>
      </template>

      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="$refs.viewTable.loadData(1)">
          <el-form-item label="仓库编号">
            <el-input v-model.trim="filter.warehouseNo" placeholder="请输入仓库编号" clearable />
          </el-form-item>
          <el-form-item label="仓库名称">
            <el-input v-model.trim="filter.warehouseName" placeholder="请输入仓库名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <wareHouseDetail ref="wareHouseDetail"></wareHouseDetail>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import wareHouseDetail from "./WareHouseDetail.vue";
export default {
  components: { viewTable, wareHouseDetail },
  data() {
    return {
      selection: [],
      filter: {
        warehouseName: "",
        warehouseNo: "",
      },
      columnsProperty: [
        {
          tooltip: true,
          key: "warehouseNo",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  color: "#2d8cf0",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.$refs.wareHouseDetail.open(params.row.warehouseNo);
                  },
                },
              },
              params.row.warehouseNo
            );
          },
        },
        {
          key: "warehouseName",
          tooltip: true,
        },
      ],
    };
  },

  methods: {
    selectHandle(selection) {
      this.selection = selection;
    },

    // 仓库打印
    printHandle() {
      if (this.selection.length > 1) {
        this.$confirm("目前仅支持单条打印", "错误", {
          type: "error",
          showCancelButton: false,
        });
        return;
      }
      const routeUrl = this.$router.resolve({
        path: "/workHousePrint",
        query: {
          params: JSON.stringify({
            warehouseNo: this.selection[0].warehouseNo,
            warehouseName: this.selection[0].warehouseName,
          }),
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
